import * as React from 'react';
import getStore from '../store/store';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { observer } from 'mobx-react';
import { setTraceDatapoints } from 'owa-analytics-actions';

@observer
export default class TraceToggle extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                <Toggle
                    checked={getStore().traceDatapoints}
                    offText="Turn on datapoint tracing"
                    onText="turn off datapoints tracing"
                    onChanged={value => setTraceDatapoints(!getStore().traceDatapoints)}
                />
            </div>
        );
    }
}
